import { render } from "./jmxzdm.vue?vue&type=template&id=7bcb4b71"
import script from "./jmxzdm.vue?vue&type=script&lang=js"
export * from "./jmxzdm.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/open-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__